export const VISITAS_PREPARATION_CHANGED = 'visitas:preparation-changed';
export const VISITAS_PREPARATION_REQUESTED = 'visitas:preparation-requested';
export const DAILY_VISITAS_TABS = ['pendientes','iniciadas','iniciadas_no_finalizadas'];
let visibleState = null;
export const getVisitasPreparationState = scope => visibleState?.scope === scope ? visibleState : null;
export const requestDailyVisitasPreparation = scope => window.dispatchEvent(new CustomEvent(VISITAS_PREPARATION_REQUESTED,{detail:{scope}}));

export function preparationClock(timestamp,timezone) {
    if (!timezone) throw new Error('La zona horaria de la empresa no está disponible.');
    const parts = new Intl.DateTimeFormat('en-CA',{ timeZone:timezone, year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',hourCycle:'h23' }).formatToParts(new Date(timestamp));
    const value = Object.fromEntries(parts.map(part => [part.type,part.value]));
    const day = `${value.year}-${value.month}-${value.day}`;
    const weekday = new Date(`${day}T12:00:00Z`).getUTCDay();
    return { day, minute:Number(value.hour)*60+Number(value.minute), workday:weekday!==0 };
}

export function nextPreparationDelay(timestamp,timezone) {
    const clock=preparationClock(timestamp,timezone);
    let target=new Date(`${clock.day}T07:30:00Z`);
    if (!clock.workday || clock.minute>=450) target.setUTCDate(target.getUTCDate()+1);
    while(target.getUTCDay()===0) target.setUTCDate(target.getUTCDate()+1);
    const localTarget=target.getTime();let candidate=localTarget;
    for(let n=0;n<4;n++) {
        const parts=Object.fromEntries(new Intl.DateTimeFormat('en-CA',{ timeZone:timezone,year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',second:'2-digit',hourCycle:'h23' }).formatToParts(new Date(candidate)).map(part=>[part.type,part.value]));
        const localAtCandidate=Date.parse(`${parts.year}-${parts.month}-${parts.day}T${parts.hour}:${parts.minute}:${parts.second}Z`);
        const corrected=candidate+(localTarget-localAtCandidate);
        if(corrected===candidate) break;candidate=corrected;
    }
    return Math.max(1,candidate-timestamp);
}

export function createDailyVisitasPreparation({ scope,timezone,client,catalog=null,forms=null,isOnline,isVisible,bridge,now=Date.now,onChange=()=>{} }) {
    let disposed=false,inFlight=null,lastAttempt=0,nativeMarkedDay=null;
    const publish = state => {
        if (disposed) return;
        visibleState={ scope,...state };onChange(visibleState);
        if (typeof window!=='undefined') window.dispatchEvent(new CustomEvent(VISITAS_PREPARATION_CHANGED,{ detail:visibleState }));
    };
    const notifyCatalog = () => {
        if (typeof window!=='undefined') window.dispatchEvent(new CustomEvent('visitas:catalog-changed',{ detail:{scope} }));
    };
    const run = ({ shiftStarted=false,requested=false,assignmentsChanged=false,formsChanged=false,retryFailed=false }={}) => {
        if (inFlight) return assignmentsChanged||formsChanged||requested?inFlight.then(()=>run({assignmentsChanged,formsChanged,requested})):inFlight;
        inFlight=(async()=>{
            if (disposed || !isVisible()) return;
            const clock=preparationClock(now(),timezone);
            const prepared=await bridge?.takePrepared?.();
            if (disposed) return;
            if (prepared?.scope===scope) {
                if (prepared.revoked) {await client.invalidate();await catalog?.invalidate();}
                else if (Array.isArray(prepared.pages) && now()-prepared.savedAt<7*86400000) {
                    const imported=await client.importPages(prepared.pages,prepared.complete);
                    if (prepared.complete && imported!==false) await client.markPrepared(prepared.day,timezone);
                }
                await bridge.acknowledge(prepared.generation);
                if(!disposed&&!prepared.revoked)catalog?.notifyPrepared?.();
            } else if (prepared?.generation) await bridge.acknowledge(prepared.generation);
            if (disposed) return;
            const saved=await client.dailyState();
            const catalogSaved=await catalog?.dailyState();
            const listsReady=saved?.day===clock.day && saved.timezone===timezone;
            const catalogReady=!catalog||(catalogSaved?.day===clock.day&&catalogSaved.timezone===timezone);
            let restoredCoverage=null;
            if (listsReady && catalogReady && !requested && !assignmentsChanged) {
                const ids=forms?await client.preparedVisitIds(DAILY_VISITAS_TABS):null;
                const coverage=forms&&ids?await forms.inspect(ids,{day:clock.day,timezone}):null;
                if (!forms || coverage?.complete) {
                    if(nativeMarkedDay!==clock.day){await bridge?.markPrepared?.(clock.day);nativeMarkedDay=clock.day;}
                    publish({ status:'ready',coverage:forms?'forms':'lists',...coverage,savedAt:saved.savedAt });return;
                }
                if (forms && coverage) {
                    restoredCoverage=Number.isSafeInteger(coverage.total)?coverage:null;
                    publish({status:'partial',coverage:'forms',...coverage,savedAt:saved.savedAt});
                }
            }
            if (!shiftStarted && !requested && !assignmentsChanged && !(catalog&&!catalogSaved) && (!clock.workday || clock.minute<450)) return;
            if (!isOnline()) {publish(restoredCoverage?{status:'partial',coverage:'forms',...restoredCoverage,savedAt:saved.savedAt}:{ status:'waiting' });return;}
            if (lastAttempt && now()-lastAttempt<300000 && !shiftStarted && !requested && !assignmentsChanged && !formsChanged && !retryFailed) return;
            lastAttempt=now();if(!assignmentsChanged)publish({status:'preparing',manual:requested});
            if(!assignmentsChanged)await bridge?.requestNow?.({refresh:requested});
            if(!assignmentsChanged && catalog && (!catalogReady||requested)) {
                const result=await catalog.prepare({day:clock.day,timezone});
                if(!result.complete){publish({status:'partial'});return;}
            }
            const results=[];
            for (const tab of listsReady&&!requested&&!assignmentsChanged?[]:DAILY_VISITAS_TABS) {
                if (disposed || !isVisible()) return;
                const params={ sync:true,summary:true,mode:'table',tab,per_page:50,sort_by:'fecha',sort_dir:'desc' };
                const result=await client.prepare(params);
                results.push({params,result});
                if (!result.complete) {if(!assignmentsChanged)publish({status:'partial'});notifyCatalog();return {complete:false};}
            }
            for (const {params,result} of results) {
                if ((await client.read({...params,page:1})).pages.length!==result.lastPage) {if(!assignmentsChanged)publish({status:'partial'});notifyCatalog();return {complete:false};}
            }
            if (disposed) return;
            await client.markPrepared(clock.day,timezone);
            let coverage=null;
            if(forms){
                const ids=await client.preparedVisitIds(DAILY_VISITAS_TABS);
                if(!ids){publish({status:'partial',coverage:'forms'});return {complete:false};}
                publish({status:'preparing',coverage:'forms',formsReady:0,total:ids.length,manual:requested});
                coverage=await forms.prepare(ids,{day:clock.day,timezone,onProgress:progress=>publish({status:'preparing',coverage:'forms',...progress,manual:requested})});
                if(disposed)return;
                if(!coverage.complete){publish({status:'partial',coverage:'forms',...coverage});notifyCatalog();return {complete:false,...coverage};}
            }
            if(!assignmentsChanged||forms){await bridge?.markPrepared?.(clock.day);nativeMarkedDay=clock.day;publish({status:'ready',coverage:forms?'forms':'lists',...coverage,savedAt:now()});}
            notifyCatalog();return {complete:true};
        })().catch(()=>{if(!assignmentsChanged)publish({status:'partial'});return {complete:false};}).finally(()=>{inFlight=null;});
        return inFlight;
    };
    return {run,dispose(){disposed=true;client.dispose();catalog?.dispose();forms?.dispose();if(visibleState?.scope===scope)visibleState=null;}};
}
